import { BrowserDatasetProvider } from '../../io/BrowserDatasetProvider';

const datasetProvider = new BrowserDatasetProvider();

export { datasetProvider };
